import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Typography, useFormControl, Button, Tooltip, IconButton, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { lowerFirst } from 'lodash-es';
import { orange } from '@material-ui/core/colors';
import { useForm } from 'react-hook-form';
import { Send } from '@material-ui/icons';
import serviciosSolicitudes from "utils/serviciosSolicitudes";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   flexGrow: 1,
  // },
  // paper: {
  //   height: 140,
  //   width: 100,
  // },
  // control: {
  //   padding: theme.spacing(2),
  // },
  // textAlign: {
  //   textAlign: 'center'
  // },
  // heidiv: {
  //   maxHeight: '140px'
  // },
  // messageRow: {
  //   // display: "flex"
  //   width: '90%'
  // },
  messageRowRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  messageBlue: {
    position: "relative",
    marginLeft: "20px",
    marginBottom: "10px",
    padding: "17px",
    backgroundColor: "#A8DDFD",
    width: "80%",
    //height: "50px",
    textAlign: "left",
    font: "400 .85em 'Open Sans', sans-serif",
    border: "1px solid #97C6E3",
    borderRadius: "10px",
    "&:after": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "15px solid #A8DDFD",
      borderLeft: "15px solid transparent",
      borderRight: "15px solid transparent",
      top: "0",
      left: "-15px"
    },
    "&:before": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "17px solid #97C6E3",
      borderLeft: "16px solid transparent",
      borderRight: "16px solid transparent",
      top: "-1px",
      left: "-17px"
    }
  },
  messageOrange: {
    position: "relative",
    marginRight: "20px",
    marginBottom: "10px",
    padding: "17px",
    backgroundColor: "#f8e896",
    width: "80%",
    //height: "50px",
    textAlign: "left",
    font: "400 .85em 'Open Sans', sans-serif",
    border: "1px solid #dfd087",
    borderRadius: "10px",
    "&:after": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "15px solid #f8e896",
      borderLeft: "15px solid transparent",
      borderRight: "15px solid transparent",
      top: "0",
      right: "-15px"
    },
    "&:before": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "17px solid #dfd087",
      borderLeft: "16px solid transparent",
      borderRight: "16px solid transparent",
      top: "-1px",
      right: "-17px"
    }
  },

  // messageContent: {
  //   padding: 0,
  //   margin: 0
  // },
  messageTimeStampRight: {
    position: "absolute",
    fontSize: ".85em",
    fontWeight: "300",
    marginTop: "10px",
    bottom: "-3px",
    right: "5px",
    padding: '4px'
  },

  orange: {
    color: theme.palette.getContrastText(orange[500]),
    backgroundColor: orange[500],
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  // // avatarNothing: {
  // //     color: "transparent",
  // //     backgroundColor: "transparent",
  // //     width: theme.spacing(4),
  // //     height: theme.spacing(4)
  // // },
  // displayName: {
  //   marginLeft: "15px"
  // },
  // divConteiner: {
  //   maxHeight: '200px'
  // }
}));

const Mensajes = ({ datoS, usuario }) => {
  const classes = useStyles();
  let nombreCompleto = usuario[0].nombre + ' ' + usuario[0].apaterno + ' ' + usuario[0].amaterno;
  return (
    <div className={classes.heidiv}>
      {datoS?.length > 0 ?
        datoS?.map(comentario => <React.Fragment>
          {nombreCompleto == comentario.npersona ?
            <div className={classes.messageRowRight}>
              <div className={classes.messageOrange}>
                <p className={classes.messageContent}>{comentario.comentario || 'N/D'}</p>
                <div className={classes.messageTimeStampRight}>{nombreCompleto + ', ' + comentario.fcrea || 'N/D'}</div>
              </div>
            </div>
            :
            <div className={classes.messageRow}>
              <div>
                {/* <div className={classes.displayName}>{comentario.npersona || 'N/D'}</div> */}
                <div className={classes.messageBlue}>
                  <div>
                    <p className={classes.messageContent}>{comentario.comentario || 'N/D'}</p>
                    <br />
                  </div>

                  <div className={classes.messageTimeStampRight}>{comentario.npersona + ', ' + comentario.fcrea || 'N/D, '}</div>
                </div>
              </div>
            </div>
          }
          {/* // <Grid item md={12} xs={12} direction='row'> */}
          {/* <Grid item md={6} xs={6} className={classes.textAlign}>
                              <Typography variant="h6"></Typography>
                          </Grid>
                          <Grid item md={6} xs={6} className={classes.textAlign}>
                              <Typography variant="h6"></Typography>
                          </Grid>
                          <Grid item md={12} xs={12}>
                              <Typography variant="body2"></Typography>
                          </Grid> */}
          {/* // </Grid> */}
        </React.Fragment>
        ) :
        <React.Fragment>
          <Grid item md={3} xs={3} className={classes.textAlign}>
          </Grid>
          <Grid item md={6} xs={6} className={classes.textAlign}>
            <Typography variant="subtitle1">No se encuentran registros</Typography>
          </Grid>
        </React.Fragment>

      }
      <br />
    </div>
  );
};

export default Mensajes;